import { render, staticRenderFns } from "./count-down.vue?vue&type=template&id=1838fa66&scoped=true"
import script from "./count-down.vue?vue&type=script&lang=js"
export * from "./count-down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838fa66",
  null
  
)

export default component.exports